import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-clusted-profile-images',
  templateUrl: './clusted-profile-images.component.html',
  styleUrls: ['./clusted-profile-images.component.scss'],
  host: { class: 'cluster-profile-image' },
})
export class SharedClustedProfileImagesComponent implements OnInit, OnChanges {
  @Input() userList?: any;
  @Input() numberToShow = 3;
  @Input() size = '30px';
  count!: number;

  constructor() {}

  ngOnInit(): void {
    this.determineRemainingCount();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userList']) {
      this.determineRemainingCount();
    }
  }

  private determineRemainingCount() {
    if (this.userList?.length > this.numberToShow) {
      this.count = this.userList.length - this.numberToShow;
    }
  }
}
